import { FC } from 'react'
import { Controller, FieldValues, ControllerRenderProps, FieldPath, Control } from 'react-hook-form'
import { TextFieldProps } from '@mui/material'
import { MoneyInput, MoneyInputProps } from './money-input.tsx'

export interface ReactHookFormMoneyInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends Omit<MoneyInputProps, 'value' | 'onChange' | 'error' | 'helperText'> {
  name: TName
  control: Control<TFieldValues>
  rules?: Parameters<typeof Controller<TFieldValues>>[0]['rules']
}

export const ReactHookFormMoneyInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  ...moneyInputProps
}: ReactHookFormMoneyInputProps<TFieldValues, TName>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <MoneyInput
          {...moneyInputProps}
          value={field.value as number | undefined}
          onChange={(cents) => field.onChange(cents)}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
        />
      )}
    />
  )
}

